import React, { useState, useEffect } from 'react'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import Translation from '../../global/Translation'
import ReactTooltip from 'react-tooltip'
import copyToClipboardIcon from '../../../assets/img/components/copy-to-clipboard.svg'
import bannerEclosImg from '../../../assets/img/banner-eclos-voucher/banner-eclos-voucher__catalog.png'

const BannerEclosVoucher = props => {
    const { intl, promotionCode } = props
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const _cardData = {
        bodyText: intl.formatMessage({ id: 'valid_only_on_eclos_slabs', defaultMessage: 'Valid only on Éclos® slabs.' }),
    }

    return (
        <div
            className="banner-eclos-voucher"
            style={{
                backgroundImage: `url(${bannerEclosImg})`,
                backgroundSize: 'cover',
                backgroundPosition: isMobile ? 'center center' : 'center left',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="banner-eclos-voucher__overlay"></div>
            <div className="banner-eclos-voucher__container">
                <div className="banner-voucher__title">
                    <div>
                        <h3 className="banner-eclos-voucher-title">
                            <Translation id="eclos_voucher_main_title_big_banner" defaultMessage="Exclusive offer for Éclos® customers!" />
                        </h3>
                    </div>
                    <div>
                        <h3 className="banner-eclos-voucher-subtitle">
                            <FormattedHTMLMessage
                                id="eclos_voucher_main_subtitle_big_banner"
                                defaultMessage="Get an instant <b>10% discount</b> on your <b>Éclos®</b> slabs."
                            />
                        </h3>
                    </div>
                    <div className="banner-eclos-voucher-valid-through">
                        <p>
                            <Translation
                                id="eclos_voucher_valid_through"
                                defaultMessage="Valid through December 31, 2026."
                            />
                        </p>
                    </div>
                </div>
                <div className="banner-voucher__cards">
                    <div>
                        <Card
                            promotionCode={promotionCode}
                            bodyText={_cardData.bodyText}
                            intl={intl}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Card = props => {
    const { promotionCode, bodyText, intl } = props
    const [promotionCopied, setPromotionCopied] = useState(false)

    const copyPromotionCodeOnClick = e => {
        e.preventDefault()
        navigator.clipboard.writeText(promotionCode).then(() => {
            setPromotionCopied(true)
            ReactTooltip.hide()
            ReactTooltip.show()
            setTimeout(() => {
                setPromotionCopied(false)
                ReactTooltip.hide()
            }, 3000)
        })
    }

    return (
        <div className="banner-voucher__card">
            <div className="banner-voucher__card-content">
                <div>
                    <h6>
                        <Translation id="enter" defaultMessage="Enter" />: {promotionCode} <Translation id="at_checkout" defaultMessage="at checkout." />
                    </h6>
                </div>
                <div style={{ display: 'flex'}}>
                    <button
                        onClick={e => copyPromotionCodeOnClick(e)}
                        data-tip={
                            promotionCopied
                                ? intl.formatMessage({ id: 'copied', defaultMessage: 'Copied' })
                                : intl.formatMessage({ id: 'copy_to_clipboard', defaultMessage: 'Copy to clipboard' })
                        }
                        className="copy-to-clipboard__btn"
                    >
                        <img src={copyToClipboardIcon} alt="copy to clipboard" />
                    </button>
                    <ReactTooltip effect="solid" place="top" />
                </div>
            </div>
            <div className="banner-voucher__card-footer">
                {bodyText && <p>{bodyText}</p>}
            </div>
        </div>
    )
}

export default injectIntl(BannerEclosVoucher)
